// extracted by mini-css-extract-plugin
export default {"text":"CancelButton_text__dIl7E","icon":"CancelButton_icon__4OTGo"};